/**
 * 跨组件通讯 KEY
 * 即通过 eventBus，而不是父组件 @[eventName]
 */

export const SHOW_EVALUATION_DIALOG = 'SHOW_EVALUATION_DIALOG'
export const SHOW_LEAVE_MESSAGE_DIALOG = 'SHOW_LEAVE_MESSAGE_DIALOG'
export const SHOW_BEFORE_DIALOG = 'SHOW_BEFORE_DIALOG'

export const APPEND_MESSAGE = 'APPEND_MESSAGE'
export const APPEND_MESSAGE_ONLY_FRONT_END = 'APPEND_MESSAGE_ONLY_FRONT_END'
export const RESEND_MESSAGE = 'RESEND_MESSAGE'
export const INSERT_MESSAGE = 'INSERT_MESSAGE'
export const WITHDRAW_MESSAGE = 'WITHDRAW_MESSAGE'
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE'
export const EVALUATE_MESSAGE = 'EVALUATE_MESSAGE'

export const BLUR_TYPING_INPUT = 'BLUR_TYPING_INPUT'

export const VIEWER_UPDATE = 'VIEWER_UPDATE'
export const VIEWER_SHOW = 'VIEWER_SHOW'
export const VIEWER_HIDE = 'VIEWER_HIDE'

export const SET_MESSAGE_VALUE_BY_ID = 'SET_MESSAGE_VALUE_BY_ID'

export const TIME_TO_INSERT_WELCOME = 'TIME_TO_INSERT_WELCOME'

export const TRIGGER_CLICK_OTHER_PANEL_ITEM = 'TRIGGER_CLICK_OTHER_PANEL_ITEM'
